<template>
  <img src='../assets/GDQ-Associates-White.svg' width=400 height=60 />
</template>
<script>
export default {
  data() {
    return {
    }
  }
}
</script>
<style>
</style>
